'use strict';
var parent = require('../../es/object/values');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-auth-js/~/core-js/stable/object/values.js
// module id = 496
// module chunks = 0